import styled from "styled-components";

export const ContainerCheckIn = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-around;
  height: 300px;
  width: 300px;
`;

export const CurrentGuestsContainer = styled.div``;

export const SelectGuests = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
`;
